import TeamContainerGroup, { TeamContainerGroupDTO } from 'models/container/TeamContainerGroup';

export default class TeamContainerService {
	toModel(container: TeamContainerGroupDTO) {
		return new TeamContainerGroup(container);
	}
}
